module.exports = __webpack_public_path__ + "h5/img/beihang.e3afa3a8.png";